// function to decode base 64 string to plain text
const decodeBase64 = (text : string) => {
    return atob(text);
}

export default decodeBase64;